export default __webpack_public_path__ + "static/media/illust-experience.9899c339.svg";